export class ForumError extends Error {
  constructor(code, message, status = null, fields = {}) {
    super(message);
    this.name = 'ForumError';
    this.code = code;
    this.status = status;
    this.fields = fields;
  }
}

export const invalidResponse = () => new ForumError('invalid_response', 'El foro ha devuelto una respuesta incompleta. Inténtalo de nuevo.');
export const staleResponse = () => new ForumError('stale_response', 'La consulta ya no corresponde a la sesión actual.');

// Never forward Axios configs, response bodies, tokens or stack traces to UI state.
export function forumError(error) {
  if (error instanceof ForumError) return error;
  const status = error && error.response && error.response.status;
  if (error && error.code === 'forum_session_changed') return staleResponse();
  const payload = error && error.response && error.response.data;
  if ([400, 403, 404, 422].includes(status) && payload && payload.meta && payload.meta.submission_state === 'rejected'
      && payload.error && payload.error.code === 'publication_rejected' && Array.isArray(payload.error.fields)) {
    const labels = { title: 'Revisa el título: texto sin HTML ni saltos de línea, hasta 255 caracteres.', html: 'Escribe un mensaje válido de hasta 100.000 caracteres.',
      section_id: 'Elige una sección en la que puedas publicar.', attachment_ids: 'Alguna imagen no está disponible. Vuelve a adjuntarla con el botón del editor.' };
    const names = { section_id: 'sectionId', attachment_ids: 'html' };
    const fields = {};
    payload.error.fields.forEach(field => { if (typeof field === 'string' && Object.prototype.hasOwnProperty.call(labels, field)) fields[names[field] || field] = labels[field]; });
    return Object.assign(new ForumError('publication_rejected', 'Revisa los datos del mensaje. Tu texto se conserva.', status, fields), { rejected: true });
  }
  if (status === 403 && payload && payload.error && payload.error.code === 'csrf_invalid') return new ForumError('csrf_invalid', 'La sesión ha caducado. Recarga la página para continuar.', 403);
  if (error && (error.__CANCEL__ || error.code === 'ERR_CANCELED')) return staleResponse();
  if (error && (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT')) {
    return new ForumError('timeout', 'La consulta está tardando demasiado. Puedes volver a intentarlo.');
  }
  const messages = {
    400: ['invalid_input', 'Revisa los filtros o datos introducidos.'],
    401: ['authentication_required', 'Inicia sesión para acceder al foro.'],
    403: ['forum_denied', 'No tienes permiso para acceder a este contenido.'],
    404: ['resource_unavailable', 'Este contenido no está disponible.'],
    409: ['conflict', 'El contenido ha cambiado. Revisa su estado antes de continuar.'],
    422: ['invalid_input', 'Revisa los datos introducidos.']
  };
  const [code, message] = messages[status] || ['forum_unavailable', 'No se pudo cargar el foro. Inténtalo de nuevo.'];
  return new ForumError(code, message, status || null);
}

export function forumEnvelope(raw) {
  if (!raw || typeof raw !== 'object' || !Object.prototype.hasOwnProperty.call(raw, 'error')) throw invalidResponse();
  if (raw.error) {
    // A successful HTTP response must not hide an API error as an empty result.
    throw new ForumError('forum_unavailable', 'No se pudo cargar el foro. Inténtalo de nuevo.');
  }
  if (!raw.data || typeof raw.data !== 'object' || !raw.meta || typeof raw.meta !== 'object') throw invalidResponse();
  return raw;
}
